import { useInfiniteQuery, type InfiniteData, type UseInfiniteQueryResult } from '@tanstack/react-query';
import { fetchControlItgcDomainOptionsPage } from '../../request/controls/controlItgcOptions.ts';

export const controlItgcDomainOptionsQueryKey = (search: string) =>
  ['controls', 'itgc-domain-options', search] as const;

export type ControlItgcDomainOptionsPageView = Awaited<ReturnType<typeof fetchControlItgcDomainOptionsPage>>;

export function useControlItgcDomainOptions(
  search: string,
  enabled = true
): UseInfiniteQueryResult<InfiniteData<ControlItgcDomainOptionsPageView>, Error> {
  return useInfiniteQuery({
    queryKey: controlItgcDomainOptionsQueryKey(search),
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      fetchControlItgcDomainOptionsPage({ page: Number(pageParam) || 1, pageSize: 20, search }),
    getNextPageParam: (lastPage) => {
      const items = lastPage.items;
      if (!Array.isArray(items) || items.length === 0) return undefined;
      const pageSize = lastPage.pageSize || 20;
      if (lastPage.isLastPage === true) return undefined;
      if (lastPage.isLastPage == null && items.length < pageSize) return undefined;
      const page = typeof lastPage.page === 'number' && Number.isFinite(lastPage.page) ? lastPage.page : 1;
      return page + 1;
    },
  });
}
